import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as constants from '../constants'
import type { Plugin } from '../plugin'

/**
 * Clears the plugin-owned current organization target.
 */
export const releaseCurrentEntityTarget = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.releaseCurrentEntityTarget.relay(forwardTo =>
      rxjs.of(
        forwardTo(
          plugin.collection.plugins.currentEntityPlugin.storage.actions
            .putInIdLookup,
          {
            input: {
              key: constants.CURRENT_ENTITY_TARGET,
              value: undefined,
            },
          },
        ),
      ),
    ).asObservable,
)
